module.exports = __webpack_public_path__ + "img/ifaxNamecard.ai.17a75924.png";